import React, { Component, Fragment } from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';

registerLocale('pt-BR', ptBr)

class DatePicker extends Component {
  static defaultProps = {
    errors: null,
  };

  render() {
    const { errors } = this.props;

    return (
      <Fragment>
        <div className={errors !== null ? 'datepicker-errors' : ''}>
          <ReactDatePicker locale="pt-BR" {...this.props} />
        </div>

        {this.props.errors !== null && <span className="helper">{this.props.errors.join(', ')}</span>}
      </Fragment>
    )
  }
}

export default DatePicker;
